import moment from 'moment';
export const getPre7DayParams = (includeTime = true) => getPreDaysParams(includeTime, 7);
export const getPreDaysParams = (includeTime = true, dayAmount) => {
    const yestodayDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
    const startDate = moment().subtract(dayAmount, 'day').format('YYYY-MM-DD');
    return includeTime ? {
        dateEnd: `${yestodayDate} 23:59:59`,
        dateStart: `${startDate} 00:00:00`,
    } : {
        dateEnd: yestodayDate,
        dateStart: startDate
    };
};
export const getPreDaysParamsIncludeToday = (includeTime = true, dayAmount) => {
    const today = moment().format('YYYY-MM-DD');
    const startDate = moment().subtract(dayAmount, 'day').format('YYYY-MM-DD');
    return includeTime ? {
        dateEnd: `${today} 23:59:59`,
        dateStart: `${startDate} 00:00:00`,
    } : {
        dateEnd: today,
        dateStart: startDate
    };
};
